import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-066a0c62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-form" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Добавление компании" }),
      _createVNode(_component_router_link, { to: "/companies/spark-kz" }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "second text small" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Отмена ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      class: "company-form__container",
      onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createVNode(_component_the_input, {
        placeholder: "Название компании",
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Сокращенное название компании",
        value: _ctx.state.shortName,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.shortName) = $event)),
        disabled: _ctx.state.is_loading
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_the_input, {
        placeholder: "БИН компании",
        value: _ctx.state.bin,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.bin) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.bin.$error,
        "validation-errors": _ctx.state_form$.bin.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "КБЕ компании",
        value: _ctx.state.kbe,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.kbe) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.kbe.$error,
        "validation-errors": _ctx.state_form$.kbe.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        class: "mt-1",
        value: _ctx.state.typeId,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.typeId) = $event)),
        placeholder: "Выберите тип компании",
        disabled: _ctx.state.is_loading,
        loading: false,
        options: _ctx.COMPANIES_TYPES,
        searchable: false,
        "search-by": "name",
        label: "name"
      }, null, 8, ["value", "disabled", "options"]),
      _createVNode(_component_the_select, {
        class: "mt-1",
        value: _ctx.state.countryId,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.countryId) = $event)),
        placeholder: "Выберите страну",
        disabled: _ctx.state.is_loading,
        options: _ctx.COUNTRIES,
        "error-text": "При получении списка стран произошла ошибка",
        "select-by": "id",
        searchable: false
      }, null, 8, ["value", "disabled", "options"]),
      _createVNode(_component_the_input, {
        placeholder: "Юридический адрес",
        value: _ctx.state.legalAddress,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.legalAddress) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.legalAddress.$error,
        "validation-errors": _ctx.state_form$.legalAddress.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Фактический адрес",
        value: _ctx.state.actualAddress,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.actualAddress) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.actualAddress.$error,
        "validation-errors": _ctx.state_form$.actualAddress.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Номер свидетельства о постановке на учёт НДС",
        value: _ctx.state.vatCertificateNumber,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.vatCertificateNumber) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.vatCertificateNumber.$error,
        "validation-errors": _ctx.state_form$.vatCertificateNumber.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Дата свидетельства о регистрации НДС",
        type: "date",
        value: _ctx.state.vatCertificateDate,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.vatCertificateDate) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.vatCertificateDate.$error,
        "validation-errors": _ctx.state_form$.vatCertificateDate.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Серия НДС",
        value: _ctx.state.vatSeries,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.vatSeries) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.vatSeries.$error,
        "validation-errors": _ctx.state_form$.vatSeries.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Банк",
        value: _ctx.state.bank,
        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.bank) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.bank.$error,
        "validation-errors": _ctx.state_form$.bank.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "БИК",
        value: _ctx.state.bik,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.bik) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.bik.$error,
        "validation-errors": _ctx.state_form$.bik.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "ИИК",
        value: _ctx.state.iik,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.iik) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.iik.$error,
        "validation-errors": _ctx.state_form$.iik.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Контактный телефон",
        value: _ctx.state.contactPhone,
        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.contactPhone) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.contactPhone.$error,
        "validation-errors": _ctx.state_form$.contactPhone.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Контактный email",
        value: _ctx.state.email,
        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.email) = $event)),
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.email.$error,
        "validation-errors": _ctx.state_form$.email.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        class: "mt-1",
        value: _ctx.state.businessModelId,
        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.businessModelId) = $event)),
        placeholder: "Бизнес модель",
        loading: false,
        options: _ctx.BUSINESS_MODELS,
        failed: false,
        "error-text": "При получении списка бизнес моделей произошла ошибка",
        "select-by": "id",
        label: "name",
        searchable: false,
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.businessModelId.$error,
        "validation-errors": _ctx.state_form$.businessModelId.$errors
      }, null, 8, ["value", "options", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_file_reader, {
        placeholder: "Оферта\\Договор компании (pdf)",
        accept: "application/pdf",
        value: _ctx.state.contract,
        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.contract) = $event)),
        disabled: _ctx.state.is_loading
      }, null, 8, ["value", "disabled"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_button, {
          type: "submit",
          class: "primary small",
          loading: _ctx.state.is_loading,
          disabled: _ctx.state.is_loading
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Добавить ")
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ], 32)
  ]))
}